import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { useToast } from '@chakra-ui/react';
import { Equipment } from '~/types';
import {
  getAllInsurance,
  getInsuranceEquipaments,
  getInsuranceList,
} from '~/services/Insurance';
import { InsuranceView } from '~/types/insurance';

export function useInsuranceEquipaments(
  id: number,
  options: UseQueryOptions<Equipment[], unknown> = {},
): UseQueryResult<Equipment[], unknown> {
  const toast = useToast();

  const result = useQuery<Equipment[], unknown>(
    ['insurance-equipament', id],
    () => getInsuranceEquipaments(id),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
      onError: () => {
        toast({
          title: 'Erro',
          description: 'Erro ao buscar dados, tente novamente',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      },
    },
  );
  return result;
}

export function useInsuranceList(
  id: number,
  options: UseQueryOptions<InsuranceView[], unknown> = {},
): UseQueryResult<InsuranceView[], unknown> {
  const toast = useToast();

  const result = useQuery<InsuranceView[], unknown>(
    ['insurance-list', id],
    () => getInsuranceList(id),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
      onError: () => {
        toast({
          title: 'Erro',
          description: 'Erro ao buscar dados, tente novamente',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      },
    },
  );
  return result;
}

export function useAllInsurance(
  options: UseQueryOptions<InsuranceView[], unknown> = {},
): UseQueryResult<InsuranceView[], unknown> {
  const toast = useToast();

  const result = useQuery<InsuranceView[], unknown>(
    ['all-insurance'],
    () => getAllInsurance(),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
      onError: () => {
        toast({
          title: 'Erro',
          description: 'Erro ao buscar dados, tente novamente',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      },
    },
  );
  return result;
}
